import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Instagram, Youtube, Linkedin } from "lucide-react";

const NAV_ITEMS = [
  { to: "/", label: "ANA SAYFA" },
  { to: "/kurumsal", label: "KURUMSAL" },
  { to: "/hizmetler", label: "HİZMETLERİMİZ" },
  { to: "/projeler", label: "PROJELER" },
  { to: "/iletisim", label: "İLETİŞİM" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0A0E1A]/90 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-20 lg:h-24">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <div className="w-11 h-11 border border-[#C9A961] flex items-center justify-center text-[#C9A961] font-heading text-lg tracking-[0.15em] group-hover:bg-[#C9A961] group-hover:text-[#0A0E1A] transition-colors">
            YK
          </div>
          <div className="hidden sm:block leading-tight">
            <div className="text-white font-heading tracking-[0.2em] text-sm">İNŞAAT</div>
            <div className="text-[#C9A961] text-[10px] tracking-[0.3em] uppercase">Müteahhitlik</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.slice(1) || "home"}`}
              className={({ isActive }) =>
                `text-xs tracking-[0.2em] font-semibold transition-colors relative py-2 ${
                  isActive ? "text-[#C9A961]" : "text-white/80 hover:text-[#C9A961]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && <span className="absolute -bottom-1 left-0 right-0 h-px bg-[#C9A961]"></span>}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="tel:05449751294"
            data-testid="navbar-phone"
            className="hidden md:flex items-center gap-2 text-[#C9A961] text-sm tracking-wider hover:text-[#DBC082] transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={1.5} />
            <span className="font-semibold">0544 975 12 94</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A0E1A] border-t border-[#1F2937]" data-testid="mobile-menu">
          <div className="px-6 py-6 space-y-4">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `block text-sm tracking-[0.2em] font-semibold py-2 ${
                    isActive ? "text-[#C9A961]" : "text-white/80"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="pt-4 border-t border-[#1F2937] flex items-center gap-4">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#C9A961]"><Instagram className="w-5 h-5" /></a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#C9A961]"><Youtube className="w-5 h-5" /></a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#C9A961]"><Linkedin className="w-5 h-5" /></a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
